import * as Radix from "@radix-ui/themes";
import * as React from "react";
import Styles from "./Logo.module.css";
import * as Images from "~/image";

export const Logo: React.FC<{ theme: "light" | "dark" }> = ({ theme }) => {
  const src =
    theme === "dark"
      ? Images.vendrLogoWithWhiteText
      : Images.vendrLogoWithBlackText;

  const logoImg = (
    <img src={src} alt="Vendr's purple icon logo" className={Styles.logo} />
  );

  return <Radix.Box className={Styles.container}>{logoImg}</Radix.Box>;
};
